<template>
    <main-dialog
        ref="declineDialog"
        :translated-header="$t('dialogs.bulkDecline.declineHeader')"
        :btn-confirm-text="$t('actions.ok')"
        :btn-cancel-text="actionsCancelText"
        has-activator
        :confirm-btn-disabled="confirmButtonDisabled"
        @confirm="confirm"
    >
        <template v-slot:actions>
            <v-btn variant="text" :disabled="isDisabled" @click="onClick">
                <div v-if="isDisabled">
                    {{ toSentenceCase($t('dialogs.bulkDecline.noPromotions')) }}
                </div>
                <div v-else>
                    {{
                        toSentenceCase(
                            $t('dialogs.bulkDecline.declinButtonTitle', {
                                number: promotionIds.length,
                            })
                        )
                    }}
                </div>
            </v-btn>
        </template>
        <template v-slot:default>
            <div class="decline-promotions">
                <h2 v-if="!confirmButtonDisabled">
                    {{
                        toSentenceCase(
                            $t('dialogs.bulkDecline.declineTitle', {
                                number: promotionIds.length,
                            })
                        )
                    }}
                </h2>
                <div v-if="successDeclinedPromotions.length" class="decline-promotions__result">
                    <icon icon-name="custom:success-circle" />
                    <span>
                        {{
                            toSentenceCase(
                                $t('dialogs.bulkDecline.successDeclineMessage', {
                                    number: successDeclinedPromotions.length,
                                })
                            )
                        }}
                    </span>
                </div>
                <div v-if="failedDeclinedPromotions.length" class="decline-promotions__result">
                    <icon icon-name="custom:failure-circle" />
                    <span>
                        {{
                            toSentenceCase(
                                $t('dialogs.bulkDecline.failedDeclineMessage', {
                                    number: failedDeclinedPromotions.length,
                                })
                            )
                        }}
                    </span>
                    <ul>
                        <li v-for="promo in failedDeclinedPromotions" :key="`failed::${promo._id}`">
                            <span>{{ promo.name }}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </template>
    </main-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        promotionIds: {
            type: Array,
            default: () => [],
        },
    },
    emits: ['decline', 'open'],
    data() {
        return {
            successDeclinedPromotions: [],
            failedDeclinedPromotions: [],
        };
    },
    computed: {
        isDisabled() {
            return !this.promotionIds.length;
        },
        confirmButtonDisabled() {
            return !!(
                this.successDeclinedPromotions.length || this.failedDeclinedPromotions.length
            );
        },
        actionsCancelText() {
            return this.confirmButtonDisabled ? 'actions.close' : 'actions.cancel';
        },
    },
    methods: {
        ...mapActions('promotions', ['bulkDeclinePromotions']),
        async confirm() {
            const result = await this.bulkDeclinePromotions({ promotionIds: this.promotionIds });
            this.successDeclinedPromotions = result.successDeclinedPromotions;
            this.failedDeclinedPromotions = result.failedDeclinedPromotions;
            if (this.successDeclinedPromotions.length) {
                this.$emit('decline', this.successDeclinedPromotions);
            }
        },
        onClick() {
            this.successDeclinedPromotions = [];
            this.failedDeclinedPromotions = [];
            this.$refs.declineDialog.open();
            this.$emit('open');
        },
    },
};
</script>

<style lang="scss" scoped>
.decline-promotions {
    min-height: 10rem;
    width: 100%;

    &__result {
        margin: 2rem 0;
        font-size: 1.5rem;
    }
}
</style>
